module.exports = __webpack_public_path__ + "static/media/whichThinnerDietaryChanges.22398ad1.mp3";